import {ChangeReportProjectTopicModel} from '../../models/entity-chart.models';
import {EntitySetting, EntitySettingGroupModel} from '../../../models/entity-setting.model';
import {
  EntityChartActions, GET_ENTITIES_COUNT_SUCCESS, GET_ENTITY_COUNT_BY_COUNTRY_SUCCESS,
  GET_ENTITY_FILTER_GROUP_BY_REGION_SUCCESS,
  GET_ENTITY_SETTINGS_SUCCESS, GetEntityCountByCountrySuccessAction, GetEntityCountSuccessAction,
  GetEntityFilterGroupByRegionSuccessAction,
  GetEntitySettingsSuccessAction
} from '../actions/entity-chart.actions';

export interface EntityChartState {
  entityChartSettings: EntitySetting[];
  entityFilterByGroup: EntitySettingGroupModel[];
  projectTopics: ChangeReportProjectTopicModel[];
  entityCount: number;
  entityCountByCountry: any;
}

const initialState: EntityChartState = <EntityChartState>{
  entityChartSettings: [],
  entityFilterByGroup: [],
  projectTopics      : [],
  entityCount        : 0,
  entityCountByCountry: null
};

export function entityChartReducer (state = initialState, action: EntityChartActions): EntityChartState {
  switch (action.type) {
    case GET_ENTITY_SETTINGS_SUCCESS:
      return <EntityChartState>{
        ...state,
        entityChartSettings: (action as GetEntitySettingsSuccessAction).entityChartSettings
      };
    case GET_ENTITY_COUNT_BY_COUNTRY_SUCCESS:
      return <EntityChartState>{
        ...state,
        entityCountByCountry: (action as GetEntityCountByCountrySuccessAction).entityCount
      };
    case GET_ENTITIES_COUNT_SUCCESS:
      return <EntityChartState>{
        ...state,
        entityCount: (action as GetEntityCountSuccessAction).payload
      };
    case GET_ENTITY_FILTER_GROUP_BY_REGION_SUCCESS:
      return <EntityChartState>{
        ...state,
        entityFilterByGroup: (action as GetEntityFilterGroupByRegionSuccessAction).payload
      };
    default:
      return <EntityChartState>{
        ...state
      };
  }
}
